import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAllCategories } from '../api/categoryApi';

export interface Category {
  categoryID: number;
  categoryName: string;
  categoryDescription: string;
  imageUrl?: string;
  displayOrder?: number;
}

const CategoryContext = createContext<{ categories: Category[] }>({ categories: [] });

export const useCategoryContext = () => useContext(CategoryContext);

export const CategoryProvider = ({ children }: { children: React.ReactNode }) => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    getAllCategories().then(response => {
      const data: Category[] = Array.isArray(response) ? response : response?.value || [];
      const sorted = [...data].sort((a, b) => {
        const orderA = a.displayOrder && a.displayOrder > 0 ? a.displayOrder : 999999;
        const orderB = b.displayOrder && b.displayOrder > 0 ? b.displayOrder : 999999;
        if (orderA !== orderB) return orderA - orderB;
        return a.categoryID - b.categoryID;
      });
      setCategories(sorted);
    }).catch(error => {
      console.error('Failed to fetch categories:', error);
      setCategories([]);
    });
  }, []);

  return (
    <CategoryContext.Provider value={{ categories }}>
      {children}
    </CategoryContext.Provider>
  );
};